<template>
  <div
    v-if="users?.length"
    class="flex items-center gap-2"
    data-cy-registration-request-per-session-overview
  >
    <app-user-avatar-stacked-list :list="users" />
    {{ label }}
  </div>
</template>

<script lang="ts" setup>
import type { OrganizationMemberView } from "~~/model/organization.model";

const properties = defineProps<{
  list: { member: OrganizationMemberView }[];
}>();

const { me } = useCurrentUser();
const { profile } = useOrganizationMemberProfile();

const { t } = useI18n();
const users = computed(() =>
  properties.list.map((item) => {
    return {
      ...item.member.user,
      full_name:
        item.member.user_id === me.value?.id
          ? t("app.form.labels.you")
          : item.member.user.full_name,
    };
  }),
);

const label = computed(() => {
  if (!users.value) return;

  const currentUserIsRegistered = users.value.some(
    (user) => user.id === me.value?.id,
  );
  const registeredCount = users.value.length;

  if (!currentUserIsRegistered) {
    return t("registration_request.per_session_overview_label.default", {
      count: registeredCount,
      organization: profile.value?.organization.name,
    });
  }

  if (registeredCount === 1) {
    return t(
      "registration_request.per_session_overview_label.only_current_user",
    );
  }

  return t(
    "registration_request.per_session_overview_label.multiple_users_including_current",
    {
      count: registeredCount - 1,
      organization: profile.value?.organization.name,
    },
  );
});
</script>
